import React, { useEffect } from 'react';
import dayjs from 'dayjs';
// import PropTypes from 'prop-types';
import HistogramCard, {
  useHistogramCard,
} from 'partial/dashboard/HistogramCard';
import DashboardSchemeCard, {
  useSchemeCard,
} from 'partial/dashboard/DashboardSchemeCard';
import HistogramRange from 'partial/components/HistogramRange';
import NavTab, { NavTabItem } from 'partial/components/NavTab';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import { useTransactionHistogram, useTransactionScheme } from '../hooks';
import TransactionCompare from '../components/TransactionCompare';
import TransactionTable from '../components/TransactionTable';
import ViewTransaction from '../components/ViewTransaction';
import DisputeTransaction from '../components/DisputeTransaction';

const txnHistogramOptions = [
  {
    id: 'transaction',
    label: 'Chart',
    hook: useTransactionHistogram,
    tableFormat: [
      {
        label: 'Label',
        key: 'label',
        id: 'label',
        className: 'font-bold',
      },
      {
        label: 'Txn',
        key: 'transaction',
        id: 'transaction',
      },
      {
        label: 'Amount',
        key: (row) => <p>{row?.amount ? `$${row?.amount}` : ''}</p>,
        id: 'amount',
      },
    ],
    defaultChart: 'line',
    dateRange: false,
  },
];

const schemeOptions = [
  {
    id: 'transactions',
    label: 'Table',
    hook: useTransactionScheme,
    tableFormat: [
      {
        label: 'Label',
        key: 'label',
        id: 'label',
        className: 'font-bold',
      },
      {
        label: 'Txn',
        key: 'transaction',
        id: 'transaction',
      },
      {
        label: 'Amount',
        key: (row) => <p>{row?.amount ? `$${row?.amount}` : ''}</p>,
        id: 'amount',
      },
    ],
    defaultSort: 'id:asc',
    table: true,
    pie: false,
    bar: false,
  },
];

const Day = () => {
  const txnHistogramProps = useHistogramCard(txnHistogramOptions);
  const schemeProps = useSchemeCard(schemeOptions);
  const [filter, setFilter] = React.useState({
    type: 'DAILY',
    from: dayjs().format('YYYY-MM-DD'),
    to: dayjs().format('YYYY-MM-DD'),
  });
  const [downloadCsv, setDownloadCsv] = React.useState({});
  useEffect(() => {
    setDownloadCsv({
      downloadCsvUrl: `wallet/v1/merchant/transactions/graph/export?type=${
        filter?.type || ''
      }&date_from=${filter?.from || ''}&date_to=${filter?.to || ''}`,
      downloadCsvFilename: `TRANSACTIONS_LOGS_DAILY_${dayjs(
        filter?.from
      ).format('DD/MM/YYYY')}`,
    });
  }, [filter]);
  return (
    <div className="space-y-5 px-8 mb-5">
      <div className="flex items-center mt-2">
        <h1 className="mr-4 font-light">Data From</h1>
        <HistogramRange
          onChange={setFilter}
          defaultValue={dayjs().format('YYYY-MM-DD')}
          defaultMode="day"
          filter={filter}
          panelClassName="left-0"
          minDate="2022-03-01"
          maxDate={dayjs().format('YYYY-MM-DD')}
        />
      </div>
      <HistogramCard {...txnHistogramProps} defaultMode="day" filter={filter} />
      <DashboardSchemeCard
        {...schemeProps}
        filter={filter}
        downloadCsvUrl={downloadCsv?.downloadCsvUrl}
        downloadCsvFilename={downloadCsv?.downloadCsvFilename}
      />
    </div>
  );
};

const Month = () => {
  const txnHistogramProps = useHistogramCard(txnHistogramOptions);
  const schemeProps = useSchemeCard(schemeOptions);
  const [filter, setFilter] = React.useState({
    type: 'MONTHLY',
    from: dayjs().startOf('M').format('YYYY-MM-DD'),
    to: dayjs().endOf('M').format('YYYY-MM-DD'),
  });
  const [downloadCsv, setDownloadCsv] = React.useState({});
  useEffect(() => {
    setDownloadCsv({
      downloadCsvUrl: `wallet/v1/merchant/transactions/graph/export?type=${
        filter?.type || ''
      }&date_from=${filter?.from || ''}&date_to=${filter?.to || ''}`,
      downloadCsvFilename: `TRANSACTIONS_LOGS_MONTHLY_${dayjs(
        filter?.from
      ).format('MMMM')}`,
    });
  }, [filter]);
  return (
    <div className="space-y-5 px-8 mb-5">
      <div className="flex items-center mt-2">
        <h1 className="mr-4 font-light">Data From</h1>
        <HistogramRange
          onChange={setFilter}
          defaultValue={dayjs().format('YYYY-MM-DD')}
          defaultMode="month"
          filter={filter}
          panelClassName="left-0"
          minDate="2022-03-01"
          maxDate={dayjs().format('YYYY-MM-DD')}
        />
      </div>
      <HistogramCard {...txnHistogramProps} defaultMode="day" filter={filter} />
      <DashboardSchemeCard
        {...schemeProps}
        filter={filter}
        downloadCsvUrl={downloadCsv?.downloadCsvUrl}
        downloadCsvFilename={downloadCsv?.downloadCsvFilename}
      />
    </div>
  );
};

const Year = () => {
  const txnHistogramProps = useHistogramCard(txnHistogramOptions);
  const schemeProps = useSchemeCard(schemeOptions);
  const [filter, setFilter] = React.useState({
    type: 'YEARLY',
    from: dayjs().startOf('year').format('YYYY-MM-DD'),
    to: dayjs().endOf('year').format('YYYY-MM-DD'),
  });
  const [downloadCsv, setDownloadCsv] = React.useState({});
  useEffect(() => {
    setDownloadCsv({
      downloadCsvUrl: `wallet/v1/merchant/transactions/graph/export?type=${
        filter?.type || ''
      }&date_from=${filter?.from || ''}&date_to=${filter?.to || ''}`,
      downloadCsvFilename: `TRANSACTIONS_LOGS_YEARLY_${dayjs(
        filter?.from
      ).format('YYYY')}`,
    });
  }, [filter]);
  return (
    <div className="space-y-5 px-8 mb-5">
      <div className="flex items-center mt-2">
        <h1 className="mr-4 font-light">Data From</h1>
        <HistogramRange
          onChange={setFilter}
          defaultValue={dayjs().format('YYYY-MM-DD')}
          defaultMode="year"
          filter={filter}
          panelClassName="left-0"
          minDate="2022-03-01"
          maxDate={dayjs().format('YYYY-MM-DD')}
        />
      </div>
      <HistogramCard {...txnHistogramProps} defaultMode="day" filter={filter} />
      <DashboardSchemeCard
        {...schemeProps}
        filter={filter}
        downloadCsvUrl={downloadCsv?.downloadCsvUrl}
        downloadCsvFilename={downloadCsv?.downloadCsvFilename}
      />
    </div>
  );
};

function DashboardTransactions() {
  const match = useRouteMatch();
  return (
    <div className="bg-white rounded-xl flex flex-col flex-1 m-5 shadow">
      <Switch>
        <Route
          exact
          path={`${match.path}/view/:uuid`}
          component={ViewTransaction}
        />
        <Route
          exact
          path={`${match.path}/dispute/:uuid`}
          component={DisputeTransaction}
        />
        <Route exact path={`${match.path}/:type(day|month|year|compare)?`}>
          <NavTab>
            <NavTabItem exact to={match.url} label="Search" />
            <NavTabItem to={`${match.url}/day`} label="Day" />
            <NavTabItem to={`${match.url}/month`} label="Month" />
            <NavTabItem to={`${match.url}/year`} label="Year" />
            <NavTabItem to={`${match.url}/compare`} label="Compare" />
          </NavTab>
          <Switch>
            <Route exact path={match.path} component={TransactionTable} />
            <Route path={`${match.path}/day`}>
              <Day key="day" />
            </Route>
            <Route path={`${match.path}/month`}>
              <Month key="month" />
            </Route>
            <Route path={`${match.path}/year`}>
              <Year key="year" />
            </Route>
            <Route path={`${match.path}/compare`}>
              <TransactionCompare />
            </Route>
          </Switch>
        </Route>
        <Route render={() => <Redirect to={match.path} />} />
      </Switch>
    </div>
  );
}

DashboardTransactions.propTypes = {};

export default DashboardTransactions;
